import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { updateRouteTracking } from "./config/analytics";
import "swiper/css/bundle";
import Clinic from "./pages/clinic/Clinic";
import Home from "./pages/home/Home";
import Search from "./pages/search/Search";
import AboutUs from "./pages/aboutus/AboutUs";
import ListYourClinic from "./pages/list-your-clinic/ListYourClinic";
import BlogIndex from "./pages/blog/BlogIndex";
import BlogArticle from "./pages/blog/BlogArticle";
import { AuthProvider } from "./pages/admin/hooks/useAuth";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ExistingClinicsPage from "./pages/admin/ExistingClinicsPage";
import DeletedClinicsPage from "./pages/admin/DeletedClinicsPage";
import ReviewPage from "./pages/admin/ReviewPage";
import BlogPostsPage from "./pages/admin/BlogPostsPage";
import BlogEditorPage from "./pages/admin/BlogEditorPage";

function App() {
	const Wrapper = ({ children }) => {
		const location = useLocation();
		useEffect(() => {
			updateRouteTracking(location.pathname);
			window.scrollTo(0, 0);
			document.body.classList.remove("opacity-0");
		}, [location.pathname, location.search]);
		return children;
	};
	return (
		<AuthProvider>
			<BrowserRouter>
				<Wrapper>
					<Routes>
						{/* Public Routes */}
						<Route path="/" element={<Home />} />
						<Route path="/search" element={<Search />} />
						<Route path="/blog" element={<BlogIndex />} />
						<Route path="/blog/:slug" element={<BlogArticle />} />
						<Route path="/about-us" element={<AboutUs />} />
						<Route path="/clinic/:id" element={<Clinic />} />
						<Route path="/list-your-clinic" element={<ListYourClinic />} />
						
						{/* Admin Routes */}
						<Route path="/admin/login" element={<AdminLogin />} />
						<Route path="/admin" element={<AdminLayout />}>
							<Route index element={<AdminDashboard />} />
							<Route path="clinics" element={<ExistingClinicsPage />} />
							<Route path="deleted-clinics" element={<DeletedClinicsPage />} />
							<Route path="blog" element={<BlogPostsPage />} />
							<Route path="blog/new" element={<BlogEditorPage />} />
							<Route path="blog/:id/edit" element={<BlogEditorPage />} />
							<Route path="review/:draftId" element={<ReviewPage />} />
							<Route path="edit-clinic/:clinicId" element={<ReviewPage />} />
							<Route path="restore-clinic/:deletedClinicId" element={<ReviewPage />} />
						</Route>
						
						<Route path="*" element={<Home />} />
					</Routes>
				</Wrapper>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
